import React, { Component } from 'react';
import _ from 'lodash';
import Picky from 'react-picky';
import 'react-picky/dist/picky.css';
import { Row, Col, Table, Button, Pagination } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import DoubleScreen from './DoubleScreen';
import { addDays } from 'date-fns';
import moment from "moment";
export default class SearchComplianceRecord extends Component {
  constructor(props){
    super(props)
    this.state= {
      selectedregionName:[],
      selectedcenterName:[],
      selectedclientName:[],
      selectedprocessName:[],
      selectedAuditType:[],
      saveClicked:false,
      activePage:1
    }
    this.bulkclientName=[]
  }
  componentWillMount = () => {  
    const{inventory} = this.props;
    if(!_.isEmpty(inventory)){      
      let regionNames = _.filter(inventory);
      this.setState({selectedregionName:regionNames[0]})
    }    
  }
  regionNames = () => {
    const{inventory} = this.props;
    if(!_.isEmpty(inventory)){
    let regionNames = _.filter(inventory); 
    return regionNames;
    }
    
  }
  
  centerNames = () => {
    const{selectedregionName} = this.state;
    if(!_.isEmpty(selectedregionName)){    
        let centerName = _.filter(selectedregionName.userCenters);
        return centerName;
    }
  }
  clientNames = () =>{
    const{selectedcenterName} = this.state;
    let clientName=[];
    if(!_.isEmpty(selectedcenterName)){
    _.map(selectedcenterName, (obj)=>{
        let x = _.filter(obj.userClients);
        clientName.push(...x );
        this.bulkclientName=clientName
    }) 
    return  _.uniqBy(clientName, 'inventoryClientId');
    }
  }
  processNames = () => {
    const{selectedclientName} = this.state;
    let processName=[];
    if(!_.isEmpty(selectedclientName)){
      _.map(selectedclientName, (obj)=>{
          let abc = _.filter(this.bulkclientName, {'inventoryClientId':obj.inventoryClientId})
          _.map(abc, (z) => {
            processName.push(...z.userProcesses)
            processName = _.uniqBy(processName, 'inventoryProcessId');
          })
      })    
    }
    return processName;
  }
  
  
  handleSelect = (e) => {
    this.setState({selectedregionName: e});
    if(!_.isEqual(this.state.selectedregionName, e)){
      this.setState({selectedcenterName:[], selectedclientName:[], selectedprocessName:[]})
    }
  }
  handleSelectCenter = (e) => {
    this.setState({selectedcenterName: e});
    if(!_.isEqual(this.state.selectedcenterName, e)){
      this.setState({selectedclientName:[], selectedprocessName:[]})
    }
  }
  handleSelectClient = (e) => {
    this.setState({selectedclientName: e});
    if(!_.isEqual(this.state.selectedclientName, e)){
      this.setState({selectedprocessName:[]})
    }
  }
  handleSelectProcess = (e) => {
    this.setState({selectedprocessName: e});  
  }
  handleChangeStart = (date) => {
    //date.setMinutes( date.getMinutes() + date.getTimezoneOffset() );
    this.setState({startDate: date});
    if(!_.isEqual(this.state.startDate, date)){
      this.setState({endDate:''})
    }
  }
  handleChangeEnd = (e) => {
    //e.setMinutes( e.getMinutes() + e.getTimezoneOffset() );
    this.setState({endDate: e});
  }
  handleDoubleClick = (i, id) => { 
    this.setState({['showDouble'+i]:true})
    this.props.action.complianceScoreCalculation(id)
  }
  onClose = (i) => {
    this.setState({['showDouble'+i]:false})
  }
  SearchTemplate = () => {
    const {selectedregionName, selectedcenterName, selectedclientName, selectedprocessName, startDate, endDate, selectedAuditType} = this.state;
   // let region ={'regionId':selectedregionName.inventoryRegionId, 'regionName':selectedregionName.inventoryRegionName}
  //  let mobile = selectedmobile
    let obj = {
      'region': {'regionId':selectedregionName.inventoryRegionId, 'regionName':selectedregionName.inventoryRegionName},
      'centerIds': _.map(selectedcenterName, (x) =>{return x.inventoryCenterId}),
      'clientIds': _.map(selectedclientName, (x) =>{return x.inventoryClientId}),
      'processIds': _.map(selectedprocessName, (x) =>{return x.inventoryProcessId}),
      'startDate':moment(startDate).format('YYYY-MM-DD'),
      'endDate':moment(endDate).format('YYYY-MM-DD'),
      'auditType':selectedAuditType
    }
    this.props.action.TokenValidation()   
    this.props.action.actionSearchCompleted(obj)
    this.setState({search:true})
  }
  renderInboxValues = (data, startOffset, startCount, Per_Page) => { 
    if(!_.isEmpty(data)){
    return _.map(data, (obj, index) =>{  
      if(index >= startOffset & startCount < Per_Page){
        startCount++;
       return(
       <tr onDoubleClick={()=>this.handleDoubleClick(index, obj.transactionNo)}>
         {this.state['showDouble'+index] ? <DoubleScreen closeModal={()=>this.onClose(index)} object={obj.values} loginUserName={this.props.loginUserName}
           action={this.props.action} ScoreCalculation={this.props.ScoreCalculation}
           /> 
         : null}
          <td>{obj.transactionNo}</td>
          <td>{obj.date}</td>            
          <td>{obj.agentName}</td>
          <td>{obj.skillSet}</td>
          <td>{obj.tlName}</td>          
          <td>{obj.callType}</td>
          <td>{obj.overallScore}</td>     
          <td>{obj.complDoneBy}</td>                 
       </tr>)
      }                     
     })
    } else {
     return(<tr><td colSpan="9">No Records Found</td></tr>)
    }
 }
 handleSelectAuditType = (e) =>{
  this.setState({selectedAuditType: e});    
 }
 validateForm = () =>{    
  const {selectedprocessName, selectedAuditType, startDate, endDate} = this.state;
    if((typeof startDate !== 'undefined')  && (typeof endDate !== 'undefined') && (typeof selectedprocessName !== 'undefined') && 
    (typeof selectedAuditType !== 'undefined')){
      return true }
  }
  resetTemplate = () =>{
    this.setState({
      selectedregionName:[],
      selectedcenterName:[],
      selectedclientName:[],
      selectedprocessName:[],
      startDate:null,
      endDate:null,
      selectedAuditType:[],
      search:false,
      activePage:1
    })
  }
  render(){
    const {search, activePage} = this.state;
    const Per_Page=50;  
    let totalPages = 1
    if(!_.isEmpty(this.props.searchData)){
      totalPages = Math.ceil(this.props.searchData.length/Per_Page)
    }
    let items = []; 
    const startOffset = (this.state.activePage-1) * Per_Page;
    let startCount = 0;
    for (let number = 1; number <= totalPages; number++) {
      items.push(
        <Pagination.Item key={number} active={number === activePage} onClick={()=>this.handleSelectPagination(number)}>
          {number}
        </Pagination.Item>				
      );
    }
    return(
    <div>
      <Row>
      <Col>
        <label>Region Name</label>
      </Col>
      <Col>
      <Picky keepOpen={false}
        value={this.state.selectedregionName}
        options={this.regionNames()}
        onChange={this.handleSelect}
        open={false}
        valueKey="inventoryRegionName"
        labelKey="inventoryRegionName"
        multiple={false}
        includeSelectAll={false}
        includeFilter={true}
        clearFilterOnClose={true}
        placeholder='Select Region'
        dropdownHeight={600}
      />
      </Col>
    </Row> 
      <Row>
      <Col>
        <label>Center Name</label>
      </Col>
      <Col>
      <Picky keepOpen={false}
        value={this.state.selectedcenterName}
        options={this.centerNames()}
        onChange={this.handleSelectCenter}
        open={false}
        valueKey="inventoryCenterName"
        labelKey="inventoryCenterName"
       multiple={true}
        includeSelectAll={false}
        includeFilter={true}
        clearFilterOnClose={true}
        placeholder='Select Center'
        dropdownHeight={600}
      />
      </Col>             
    </Row>
      <Row>
      <Col>
        <label>Client Name</label>
      </Col>
      <Col>
    <Picky keepOpen={false}
      value={this.state.selectedclientName}
      options={this.clientNames()}
      onChange={this.handleSelectClient}
      open={false}
      valueKey="inventoryClientName"
      labelKey="inventoryClientName"
     multiple={true}
      includeSelectAll={false}
      includeFilter={true}
      clearFilterOnClose={true}
      placeholder='Select Client'
      dropdownHeight={600}
    />
    </Col>
    </Row> 
      <Row>
      <Col>
      <label>Process Name</label>
      </Col>
      <Col>
      <Picky keepOpen={false}
      value={this.state.selectedprocessName}
      options={this.processNames()}
      onChange={this.handleSelectProcess}
      open={false}
      valueKey="inventoryProcessName"
      labelKey="inventoryProcessName"
     multiple={true}
      includeSelectAll={false}
      includeFilter={true}
      clearFilterOnClose={true}
      placeholder='Select Process Name'
      dropdownHeight={600}
    />
     </Col>
     </Row> 
      <Row>
     <Col>
     <label>Compliance Audit Types</label>
     </Col>
     <Col>
     <Picky keepOpen={false}
       value={this.state.selectedAuditType}
       options={this.props.auditTypes? this.props.auditTypes.complianceTypeAudit: []}
       onChange={this.handleSelectAuditType}
       open={false}
      // valueKey="label"
      // labelKey="label"
       multiple={false}
       includeSelectAll={false}
       includeFilter={false}
       placeholder='Select Audit Types'
       dropdownHeight={600}      
     />
      </Col>
      </Row>
      <Row>
        <Col>
        <label>Date Range<span className='RedColoring'>*</span></label>
       </Col>
        <Col className='myContainter'>
        <DatePicker
           selected={this.state.startDate}
           className='myDatePicker'
           selectsStart
           showMonthDropdown
           startDate={this.state.startDate}
           endDate={this.state.endDate}
           onChange={this.handleChangeStart}
           placeholderText="Select a date Range"           
           maxDate={addDays(this.state.startDate, 14)}
          />
        <DatePicker
          selected={this.state.endDate}
          selectsEnd
          startDate={this.state.startDate}
          endDate={this.state.endDate}
          onChange={this.handleChangeEnd}
          minDate={this.state.startDate}
          placeholderText="Select a date Range"          
          maxDate={addDays(this.state.startDate, 14)}
          />    
       </Col> 
     </Row> 
     <br/>
     <center><Button onClick={this.SearchTemplate} className='buttonwidth'disabled={!this.validateForm()}>Search</Button>
     &nbsp;<Button onClick={this.resetTemplate} className='buttonwidth'>Reset</Button></center>
        {((search)) ?  
        <p className='calibration'>
        <Table responsive>
          <thead>
            <th>TRANSACTION NO</th>              
            <th>TRANSACTION DATE</th>    
            <th>AGENT NAME</th>  
            <th>AGENT SKILLSET</th>
            <th>TL NAME</th>
            <th>CALL TYPE</th>
            <th>OVERALL SCORE</th>
            <th>COMPLIANCE DONE BY</th>
          </thead>
          <tbody>
            { this.renderInboxValues(_.cloneDeep(this.props.searchData), startOffset, startCount, Per_Page)}    
          </tbody>
        </Table>
        {!_.isEmpty(items) ?
    <Pagination>
			<Pagination.First  disabled={activePage === 1} onClick={()=>this.handleSelectPagination(1)} />
			<Pagination.Prev   disabled={activePage === 1} onClick={this.handleSelectPaginationPrev} />
        {items[activePage-1]}
        {items[activePage] ? items[activePage] : (activePage !== 1) ? items[0] : null}
        {items[activePage+1]}
			<Pagination.Next disabled={activePage === totalPages} onClick={this.handleSelectPaginationNext}/>
		  <Pagination.Last disabled={activePage === totalPages} onClick={()=>this.handleSelectPagination(totalPages)}/>			
		</Pagination> : null}
       
       </p>: null}      
  </div>)
  }
}